import { useState } from "react";
import { Clock, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "../../lib/api";

const OPTIONS = [15, 30, 45, 60, 90, 120, 180];
const hm = (s) => new Date(s).toLocaleTimeString("es-AR", { hour: "2-digit", minute: "2-digit", timeZone: "America/Argentina/Buenos_Aires" });

export const DelayNotice = ({ endpoint, delays = [], onSent, dark = false }) => {
  const [open, setOpen] = useState(false);
  const [minutes, setMinutes] = useState(30);
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async () => {
    if (!window.confirm(`¿Avisar por email a todos los pasajeros una demora de ${minutes} minutos?`)) return;
    setBusy(true);
    try {
      const { data } = await api.post(endpoint, { minutes: Number(minutes), message });
      toast.success(`Aviso enviado a ${data.emails} email(s) · ${data.passengers} pasaje(s) sin subir`);
      setOpen(false); setMessage(""); onSent?.();
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  const box = dark ? "bg-white/10 text-white" : "bg-amber-50 text-amber-950 ring-1 ring-amber-200";
  return (
    <div data-testid="delay-notice" className={`rounded-2xl p-4 ${box}`}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="flex items-center gap-2 font-bold"><Clock className="h-4 w-4" /> Aviso de demora</p>
        {!open && <button onClick={() => setOpen(true)} data-testid="delay-open" className="rounded-full bg-amber-400 px-4 py-2 text-sm font-bold text-[var(--ink)]">Avisar demora</button>}
      </div>
      {delays.length > 0 && <p data-testid="delay-history" className="mt-1 text-xs">Avisos enviados: {delays.map((x) => `${x.minutes} min (${hm(x.at)}, ${x.by})`).join(" · ")}</p>}
      {open && (
        <div className="mt-3 grid gap-2 sm:grid-cols-[140px_1fr_auto]">
          <select data-testid="delay-minutes" value={minutes} onChange={(e) => setMinutes(e.target.value)} className="h-11 rounded-xl border border-black/10 bg-white px-3 text-[var(--ink)]">
            {OPTIONS.map((m) => <option key={m} value={m}>{m} minutos</option>)}
          </select>
          <input data-testid="delay-message" value={message} onChange={(e) => setMessage(e.target.value)} maxLength={300} placeholder="Motivo o aclaración (opcional)" className="h-11 rounded-xl border border-black/10 bg-white px-3 text-[var(--ink)]" />
          <div className="flex gap-2">
            <button onClick={send} disabled={busy} data-testid="delay-send" className="inline-flex h-11 items-center gap-2 rounded-xl bg-[var(--ink)] px-4 text-sm font-bold text-white">{busy && <Loader2 className="h-4 w-4 animate-spin" />} Enviar</button>
            <button onClick={() => setOpen(false)} data-testid="delay-cancel" className="h-11 rounded-xl px-3 text-sm font-semibold">Cancelar</button>
          </div>
        </div>
      )}
    </div>
  );
};
